import React from 'react';

import PromotionShow from 'components/Tvendo/Article/Operations/Promotion/Show.js';

export default function () {
  return <PromotionShow />;
}
